import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Page from 'Components/Page';
import { withStyles } from '@material-ui/core';
//import { lodash } from 'lodash';
import MaterialTable from 'material-table';
import clsx from 'clsx';
import firebaseService from 'Services/firebaseService';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const styles = theme => ({});

const columns = [
  {
    title: 'Name',
    field: 'name',
    width: 200,
  },
  {
    title: 'Email',
    field: 'email',
    width: 200,
  },
  {
    title: 'Address',
    field: 'address',
    width: 200,
  },
  {
    title: 'City',
    field: 'city',
    width: 200,
  },
  {
    title: 'State',
    field: 'state',
    width: 200,
  },
  {
    title: 'Zip Code',
    field: 'zip',
    width: 200,
  },
  {
    title: 'Country',
    field: 'country',
    width: 200,
  },
  {
    title: 'Order Number',
    field: 'orderNumber',
    width: 200,
  },
  {
    title: 'Serial Number',
    field: 'serialNumber',
    width: 200,
  },
  {
    title: 'Purchase Date',
    field: 'purchaseDate',
    width: 200,
  },
  {
    title: 'Purchase Price',
    field: 'purchasePrice',
    width: 200,
  },
];

const components = {
  Container: props => <div>{props.children}</div>,
};

const options = {
  search: true,
  paging: false,
  filtering: true,
  tableLayout: 'fixed',
  exportButton: {
    csv: true,
    pdf: true,
  },
  exportFileName: '[Customer Name] - Customers',
  exportPdf: (columns2, data2) => {
    console.log('columns', columns2);
    console.log('data', data2);

    const headRows = columns.reduce((acc, columnRow) => {
      acc[columnRow.field] = columnRow.title;
      return acc;
    }, {});
    console.log('headRows', [headRows]);

    let content = {
      startY: 50,
      head: [headRows],
      body: data2,
    };

    const unit = 'pt';
    const size = 'A4';
    const orientation = 'landscape';

    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(15);
    doc.text('[Customer Name] - Customers', 40, 40);
    doc.autoTable(content);
    doc.save('[Customer Name] - Customers.pdf');
  },
};

const localization = {
  toolbar: {
    exportTitle: 'Export', // Tooltip for Export Button
    exportCSVName: 'Export as CSV', // Button to download CSV
    exportPDFName: 'Export as PDF', // Button to download PDF
  },
};

function Customers({ classes, regCodeId }) {
  const [customerData, setCustomerData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  useEffect(() => {
    (async function () {
      try {
        console.log('geting customer data with :: ', regCodeId, page, limit);
        const _customerData = await firebaseService.getCustomerData(regCodeId, page, limit);

        setCustomerData(_customerData);
      } catch (err) {
        console.warn('Contact server error: ', err);
        return;
      }
    })();
  }, [limit, page, regCodeId]);
  return (
    <Page>
      <Container component="main" maxWidth="lg">
        <Typography variant="h1" className={classes.pageHeader}>
          Customer Data {regCodeId && `for ${regCodeId}`}
        </Typography>

        <MaterialTable
          title="Product Name"
          data={customerData}
          columns={columns}
          options={options}
          components={components}
          localization={localization}
        />
      </Container>
    </Page>
  );
}

function mapStateToProps({}, ownProps) {
  return {
    regCodeId: ownProps.match.params.id,
  };
}

export default withRouter(connect(mapStateToProps)(withStyles(styles)(Customers)));
